import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../../Extra/Loading";
import { secondsToHHMM } from "../../../../Utilitie";
import DownloadExcel from "../../../../Extra/DownloadExcel";

const urlPrefix = process.env.REACT_APP_URL_PREFIX;
const TakenOverDayWise = ({ data, date }) => {
  /////////////////////////////////////
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const tableRef = useRef();
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  /////////////////////////////////////

  return (
    <div>
      {" "}
      <div className="papaDiv">
        <h5 className="bg-dark text-white text-center p-2">
          Long Haul Taken Over
        </h5>
        <div
          className="table-responsive table-wrapper"
          style={{ maxHeight: "650px" }}
        >
          {loading && <Loading />}
          <table
            ref={tableRef}
            className="table table-bordered table-striped mb-4 papaDiv"
            style={{ fontSize: "11px" }}
          >
            <thead
              className="table-dark text-center align-middle    sticky-top"
              style={{ zIndex: 1 }}
            >
              <tr>
                <th>SR NO. </th>
                <th>DATE</th>
                <th>EX</th>
                <th>TRAIN NO.</th>
                <th>ENGINE NO.</th>
                <th>DEP</th>
                <th>ARR</th>
                <th>DETN</th>
                <th>STN</th>
                <th>TP AND SP</th>
                <th>REMARKS</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center">
                    No data available
                  </td>
                </tr>
              ) : (
                data &&
                data.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{row.A_DATE.slice(0, 10)}</td>

                    <td>{row.EX}</td>
                    <td>
                      {row.TRAIN_NO_1}{" "}
                      {row.TRAIN_NO_2 && ` - ${row.TRAIN_NO_2}`}
                    </td>
                    <td>
                      {row.ENGINE_NO}
                      {row.ENGINE_NO_II && ` & ${row.ENGINE_NO_II}`}
                    </td>
                    <td>{secondsToHHMM(row.DEP)}</td>
                    <td>{secondsToHHMM(row.ARRIVAL)}</td>
                    <td>{secondsToHHMM(row.DETENTION)}</td>
                    <td>{row.STATION}</td>
                    <td>{row.TP_SP}</td>
                    <td>{row.REMARKS}</td>
                  </tr>
                ))
              )}
            </tbody>
            {/* <tfoot>
              <tr>
                <td colSpan={7}>total</td>
                <td>
                  {data.reduce((sum, item) => sum + (item.DETENTION || 0), 0)}
                </td>
              </tr>
            </tfoot> */}
          </table>
        </div>
      </div>
      <DownloadExcel
        tableRef={tableRef}
        fileName={`  Long Haul Taken Over  Report -  ${date.start}-${date.end}
        
            `}
      />
    </div>
  );
};

export default TakenOverDayWise;
